import React from "react";
import PropTypes from "prop-types";
import User from "../../components/user/userForm";
import Layout from "../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const CourseFormPage = () => {
  // let { uuid } = useParams();
  return <Layout body={<User />} />;
};

CourseFormPage.propTypes = {};

export default CourseFormPage;
